import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Row, Divider, Button } from "antd";
import {
  ValimateConfigurationResultDto,
  ValimateTestCaseResultDto,
} from "../../autogenerated/models";
import FileDownload from "js-file-download";
import TucResultActions from "./TucResultActions";
import TucResultSummary from "./TucResultSummary";
import StepResultTable from "./StepResultTable";
import { DowloadExecutionStepFiles } from "../../store/api";
import ExecutionStatusSelector from "./ExecutionStatusSelector";

import TruncatedFileNames from "../TruncatedFileNames";
import {
  setIsDownloading,
  TestCaseRerun,
} from "../../store/slices/valimateSlice";
import { FileZipOutlined } from "@ant-design/icons";

interface TucResultProps {
  configurationResult: ValimateConfigurationResultDto;
  result: ValimateTestCaseResultDto;
  reruns: Array<TestCaseRerun>;
  enableReruns: boolean;
  downloading: boolean;
  sessionId: string;
  confIndex: number;
  index: number;
}

const TucResult: React.FC<TucResultProps> = ({
  configurationResult = {},
  result = {},
  enableReruns = false,
  downloading = false,
  reruns = [],
  sessionId = "",
  confIndex = 0,
  index = 0,
}) => {
  const dispatch = useDispatch();

  const DowloadExecutionStep = useCallback(
    (sessionId, stepId, configurationId, filename) => {
      dispatch(setIsDownloading(true));
      DowloadExecutionStepFiles(sessionId, stepId, configurationId)
        .then((response: Blob) => {
          if (response && response.size > 0)
            FileDownload(response, `${filename}_${Date.now()}.zip`);
        })
        .finally(() => dispatch(setIsDownloading(false)));
    },
    [dispatch]
  );

  return (
    <>
      <Row>
        <TucResultActions
          configurationResult={configurationResult}
          result={result}
          enableReruns={enableReruns}
          rerunning={reruns.some(
            (rerun) =>
              rerun.configurationId ===
                configurationResult.testConfiguration?.id &&
              rerun.testCaseId === result.testCase?.id
          )}
          downloading={downloading}
          sessionId={sessionId}
        ></TucResultActions>
        <TucResultSummary
          configurationResult={configurationResult}
        ></TucResultSummary>
      </Row>

      <Divider></Divider>

      {configurationResult.execution?.callback?.errorDescription ? (
        <>
          <p>{configurationResult.execution?.callback?.errorDescription}</p>
          <Divider></Divider>
        </>
      ) : (
        ""
      )}

      {configurationResult.execution?.callback?.steps?.map(
        (executionStep, executionStepIndex) => {
          let testStep = result.testCase?.testSteps?.find(
            (ts) => ts.id === executionStep.stepId
          );

          let configurationFiles = configurationResult.testConfiguration?.name
            ? testStep?.testFiles?.filter(
                (tf) =>
                  tf.testConfigurationId ===
                  configurationResult.testConfiguration?.id
              )
            : testStep?.testFiles;

          var filesNames =
            configurationFiles?.flatMap(
              (tf) =>
                `${
                  tf.contentFileNames ? tf.contentFileNames : [tf.name ?? ""]
                } ${tf.testDatasetIndex ?? ""}`
            ) ?? [];

          return (
            <React.Fragment
              key={`r-${index}-exstep-${confIndex}-${executionStepIndex}`}
            >
              <h3 className="tucName">
                {
                  <>
                    {testStep
                      ? `${testStep?.no}: ${testStep?.description} - `
                      : "-: -"}{" "}
                    <ExecutionStatusSelector step={executionStep} />
                  </>
                }
              </h3>
              <p>
                {" "}
                <Button
                  icon={<FileZipOutlined />}
                  loading={downloading}
                  disabled={filesNames?.length === 0}
                  onClick={() =>
                    DowloadExecutionStep(
                      sessionId,
                      testStep?.id,
                      configurationResult.testConfiguration?.id,
                      `${sessionId}-${testStep?.no}-${configurationResult.testConfiguration?.name}`
                    )
                  }
                >
                  Download step files
                </Button>
                {"  "}
                <TruncatedFileNames
                  fileNames={filesNames}
                  maxLength={100}
                  keyProp={`r-${index}-exstep-${confIndex}-${executionStepIndex}`}
                ></TruncatedFileNames>
              </p>
              <StepResultTable
                step={executionStep}
                configurationId={
                  configurationResult.testConfiguration?.id ?? ""
                }
              />
            </React.Fragment>
          );
        }
      )}
    </>
  );
};

export default TucResult;
